import { Divider, Drawer, Spin } from 'antd';
import { Form, Formik } from 'formik';
import { observer } from 'mobx-react-lite';
import React, { Dispatch, SetStateAction, useEffect, useState } from 'react';
import { formatCep, formatDocument, formatPhone } from '../../../utils/TextFormatters';
import { formatDateAndTime } from '../../../utils/dateFunctions';
import { formatCurrency } from '../../../utils/functions';
import customerStore from '../../../stores/customerStore';

export const statusOptions = [
    {
        value: 'PENDING',
        label: 'Pendente'
    },
    {
        value: 'ACCEPTED',
        label: 'Aprovado'
    },
    {
        value: 'REJECTED',
        label: 'Reprovado'
    }
];


interface DescriptionItemProps {
    title: string;
    content: React.ReactNode;
}

const DescriptionItem = ({ title, content }: DescriptionItemProps) => (
    <div className="flex gap-1 pb-2">
        <p className="inline-block pr-2 text-gray-500 font-normal">{title}:</p>
        <p className="font-semibold text-zinc-800 font-medium">{content}</p>
    </div>
);

interface ModalClienteProps {
    isModalOpen: boolean;
    setIsModalOpen: Dispatch<SetStateAction<boolean>>;
    customerUuid: any;
    notViewClientUnitsActive?: boolean;
}

const ModalCliente: React.FC<ModalClienteProps> = observer(({ isModalOpen, notViewClientUnitsActive, setIsModalOpen, customerUuid }) => {
    const [customer, setCustomerUuid] = useState<any>();
    const [loading, setLoading] = useState<any>();


    useEffect(() => {
        setLoading(true);
        const getInformation = async () => {
            const response = await customerStore.getCustomerByUuid(customerUuid);
            setCustomerUuid(response);
            setLoading(false);
        }

        getInformation();
    }, [])


    return (
        <Drawer
            title="Informações Cliente"
            width={600}
            onClose={() => setIsModalOpen(false)}
            open={isModalOpen}
        >
            <div>
                {loading &&
                    <div className="flex justify-center"><Spin size="default" /></div>
                }

                {!loading &&
                    <div>

                        <p className="pb-4 text-base text-primary-color">Dados de Contato</p>

                        <div>
                            <DescriptionItem title={customer?.entity === "JURIDICA" ? "Nome Fantasia" : "Nome"} content={customer?.firstName} />
                        </div>

                        {customer?.lastName && <div>
                            <DescriptionItem title={customer?.entity === "JURIDICA" ? "Razão Social" : "Sobrenome"} content={customer?.lastName} />
                        </div>}

                        <div className="grid grid-cols-2 gap-4" >
                            <DescriptionItem title="Documento" content={formatDocument(customer?.document)} />
                            <DescriptionItem title="Status do Cadastro" content={customer?.active ? "Ativo" : "Inativo"} />
                        </div>

                        <div className="grid grid-cols-2 gap-4" >
                            <DescriptionItem title="Celular" content={formatPhone(customer?.mobile)} />
                            <DescriptionItem title="Telefone Fixo" content={formatPhone(customer?.phone)} />
                        </div>

                        <div>
                            <DescriptionItem title="Email" content={customer?.user?.email} />
                        </div>

                        <div className="grid grid-cols-2 gap-4">
                            <DescriptionItem title="Número com Whatsapp?" content={customer?.mobileWhatsapp ? "Sim" : "Não"} />
                        </div>


                        <Divider />

                        {customer?.mainAddress &&
                            <>
                                <p className="pb-4 text-base text-primary-color">Endereço de Entrega</p>

                                <div >
                                    <DescriptionItem title="Endereço" content={`${customer?.mainAddress?.street} - ${customer?.mainAddress?.number}`} />
                                </div>

                                <div>
                                    <DescriptionItem title="Bairro" content={customer?.mainAddress?.block} />
                                </div>

                                <div className="grid grid-cols-2 gap-4" >
                                    <DescriptionItem title="Cidade" content={customer?.mainAddress?.city} />
                                    <DescriptionItem title="Estado" content={customer?.mainAddress?.state} />
                                </div>

                                <div className="grid grid-cols-2 gap-4" >
                                    <DescriptionItem title="Pais" content='Brasil' />
                                    <DescriptionItem title="CEP" content={formatCep(customer?.mainAddress?.zipCode)} />
                                </div>

                                {customer?.mainAddress?.addressComplement && <div className="grid grid-cols-1">
                                    <DescriptionItem title="Complemento" content={customer?.mainAddress?.addressComplement} />
                                </div>}
                            </>
                        }
                    </div>
                }
            </div>
        </Drawer>
    );
});

export default ModalCliente;
